import {
  teamsStoreSelector,
  useTeamsStore,
} from '@repo/editor/src/stores/teamsStore';
import { withEventScope } from '@repo/event-processor';
import { Button } from '@repo/ui/components/Buttons';
import { H2, P1 } from '@repo/ui/components/Typography';

import CreateTeamFlow from 'components/Layout/CreateTeamFlow/CreateTeamFlow';
import { FlexColumn } from 'styles/layouts';

import { Wrapper } from './styles';

const TeamCreationBanner: React.FC = () => {
  const showCreateTeamModal = useTeamsStore(
    teamsStoreSelector.showCreateTeamModal
  );
  const setShowCreateTeamModal = useTeamsStore(
    teamsStoreSelector.setShowCreateTeamModal
  );

  return (
    <>
      <Wrapper>
        <FlexColumn gap="24px">
          <H2>New: Kittl for teams</H2>
          <P1>
            Unlock the true potential of collaboration and take your
            <br /> design projects to new heights. Seamlessly connect with
            <br /> your teammates, share ideas, and work on projects
            <br /> together.
          </P1>
          <Button
            height="48px"
            label="Create a Team"
            name="createTeamButton"
            width="162px"
            onClick={(): void => setShowCreateTeamModal(true)}
          />
        </FlexColumn>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img alt="Team creation graphic" src="/images/teamCreation.svg" />
      </Wrapper>
      <CreateTeamFlow
        isOpen={showCreateTeamModal}
        onClose={(): void => setShowCreateTeamModal(false)}
      />
    </>
  );
};

export default withEventScope(TeamCreationBanner, {
  module: 'teamCreationBanner',
});
